import { useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

export const useModules = (space = 'main') => {
  // The same manager serves two spaces; inside Platinum+ these are called trainings.
  const noun = space === 'platinum_plus' ? 'Training' : 'Module';
  const [modules, setModules] = useState([]);
  const [editingModule, setEditingModule] = useState(null);
  const [moduleForm, setModuleForm] = useState({
    title: '',
    description: '',
    order: 1,
    is_locked: true,
    required_previous_module: '',
    days_delay: 0
  });

  const fetchModules = async () => {
    try {
      const response = await axios.get(`${API}/modules?space=${space}`);
      setModules(response.data);
    } catch (error) {
      toast.error('Failed to load modules');
    }
  };

  const saveModule = async () => {
    if (!moduleForm.title.trim()) {
      toast.error(`Give the ${noun.toLowerCase()} a title first`);
      return;
    }
    try {
      const token = localStorage.getItem('token');
      if (editingModule) {
        await axios.put(`${API}/modules/${editingModule}`, { ...moduleForm, space }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(`${noun} updated`);
      } else {
        await axios.post(`${API}/modules`, { ...moduleForm, space }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(`${noun} created`);
      }
      resetModuleForm();
      fetchModules();
    } catch (error) {
      toast.error(error.response?.data?.detail || (editingModule ? 'Update failed' : 'Creation failed'));
    }
  };

  const deleteModule = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/modules/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(`${noun} deleted`);
      fetchModules();
    } catch (error) {
      toast.error('Delete failed');
    }
  };

  const handleEditModule = (module) => {
    setEditingModule(module.id);
    setModuleForm({
      title: module.title,
      description: module.description,
      order: module.order,
      is_locked: module.is_locked,
      required_previous_module: module.required_previous_module || '',
      days_delay: module.days_delay || 0
    });
  };

  const resetModuleForm = () => {
    setEditingModule(null);
    setModuleForm({
      title: '',
      description: '',
      order: 1,
      is_locked: true,
      required_previous_module: '',
      days_delay: 0
    });
  };

  return {
    modules,
    editingModule,
    moduleForm,
    setModuleForm,
    fetchModules,
    saveModule,
    deleteModule,
    handleEditModule,
    resetModuleForm
  };
};

export default useModules;
